/*
 * @Description:
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2022-03-15 23:07:32
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-03-15 23:11:29
 */
export function calculateTableHeight(ref, callback) {
  const clientHeight = document.body.clientHeight;
  const appHeader = 60;
  const tabHeight = 40;
  const searchHeight = ref ? ref.$el.scrollHeight : 0;
  const paginationHeight = 72;
  const tabelHeight =
    clientHeight - appHeader - tabHeight - paginationHeight - searchHeight - 50;
  if (callback) {
    callback();
  }
  return tabelHeight;
}
